import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-light",
  "use": "icon-arrow-up-light-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up-light\">\n<path d=\"M10.625 7.3937L12.8688 9.6312L13.75 8.75L10 5L6.25 8.75L7.1312 9.6312L9.375 7.3937V15H10.625V7.3937Z\" fill=\"#CCD3DD\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol